import React from 'react';
import PropTypes from 'prop-types';

import { Provider } from 'react-redux';
import { applyMiddleware, createStore } from 'redux';
import { composeWithDevTools } from 'redux-devtools-extension';
import reduxThunk from 'redux-thunk';

import reducers from '../reducers';

const createStoreWithMiddleware = applyMiddleware(reduxThunk)(createStore);

/* eslint-disable no-undef */
// TODO check if local env
const store = createStoreWithMiddleware(reducers, composeWithDevTools());
/* eslint-enable no-undef */

const StoreProvider = ({ onStartup, children, ...rest }) => {
  React.useEffect(() => {
    onStartup && onStartup(store);
  }, [onStartup]);
  
  return (
    <Provider
      {...rest}
      store={store}>
      {children}
    </Provider>
  );
};

StoreProvider.propTypes = {
  children: PropTypes.node.isRequired,
  onStartup: PropTypes.func,
};

export default StoreProvider;
